export const data = [
    {
      id: 1,
      product_title: "Powerful Gaming Laptop with Impressive Graphics",
      product_review: "If you're looking for a laptop that can handle intensive gaming, the ASUS ROG Strix Scar III is definitely worth considering. With its NVIDIA GeForce RTX 2070 graphics card and 9th Gen Intel Core i7 processor, this laptop delivers top-notch performance for even the most demanding games.",
      review_user: {name: "Md Tared", image: "/assets/review/profile-icon.png", upload_date: "5 days ago"}
    },
    {
      id: 2,
      product_title: "Sleek and Portable Laptop for Everyday Use",
      product_review: "The Dell XPS 13 is a great choice if you're looking for a laptop that's lightweight, stylish, and has a long battery life. The 13.3-inch display features a resolution of 1920x1080, which delivers crisp and clear images. The laptop runs on an Intel Core i5 processor and has 8GB of RAM",
      review_user: {name: "Md Rohim Khan", image: "/assets/review/profile-icon.png", upload_date: "5 days ago"}
    },
    {
      id: 3,
      product_title: "Affordable Laptop for Students on a Budget",
      product_review: "The Acer Aspire 5 is a great option for students who need a reliable laptop without breaking the bank. The 15.6-inch display features a resolution of 1920x1080, which is perfect for studying, browsing the web, or watching videos. The laptop runs on an AMD Ryzen 3 processor and has 4GB of RAM",
      review_user: {name: "Md Saidul", image: "/assets/review/profile-icon.png", upload_date: "3 days ago"}
    },
    {
      id: 4,
      product_title: "Versatile 2-in-1 Laptop for Work and Play",
      product_review: "The Lenovo Yoga C940 is a versatile 2-in-1 laptop that can be used for both work and play. The 14-inch display features a resolution of 1920x1080 and can be rotated 360 degrees to transform the laptop into a tablet. The laptop runs on an Intel Core i7 processor and has 12GB of RAM",
      review_user: {name: "Md Karim", image: "/assets/review/profile-icon.png", upload_date: "5 days ago"}
    },
    {
      id: 5,
      product_title: "MacBook Pro: The Ultimate Laptop for Apple Fans",
      product_review: "The MacBook Pro is a top-of-the-line laptop for Apple fans who need a powerful and reliable device for work or creative projects. The 13-inch display features a resolution of 2560x1600, which delivers stunning visuals. The laptop runs on an Apple M1 chip and has 8GB of RAM",
      review_user: {name: "Junayeed Khan", image: "/assets/review/profile-icon.png", upload_date: "9 days ago"}
    },
    {
      id: 6,
      product_title: "Budget-Friendly Chromebook for Simple Tasks",
      product_review: "The HP Chromebook 14 is a budget-friendly laptop that's perfect for simple tasks like browsing the web, checking emails, or streaming videos. The 14-inch display features a resolution of 1366x768, which is adequate for basic use.",
      review_user: {name: "Rofiqul Islam", image: "/assets/review/profile-icon.png", upload_date: "22 days ago"}
    },
    {
      id: 7,
      product_title: "High-End Laptop with Stunning 4K Display",
      product_review: "The Dell XPS 15 is a high-end laptop that's perfect for professionals who need a powerful device for video editing, graphic design, or other intensive tasks. The 15.6-inch 4K display features a resolution of 3840x2160, which delivers stunning visuals.",
      review_user: {name: "Sadid Ahmed", image: "/assets/review/profile-icon.png", upload_date: "13 days ago"}
    },
    {
      id: 8,
      product_title: "Gaming Laptop with Advanced Cooling System",
      product_review: "The MSI GE75 Raider is a gaming laptop that's perfect for gamers who need a device that can handle even the most demanding games. The 17.3-inch display features a resolution of 1920x1080 and has a refresh rate of 144Hz, which delivers smooth and clear visuals.",
      review_user: {name: "Hasan Ali", image: "/assets/review/profile-icon.png", upload_date: "13 days ago"}
    },
    {
      id: 9,
      product_title: "Ultra-Thin Laptop with Impressive Battery Life",
      product_review: "The LG Gram 14 is an ultra-thin laptop that's perfect for on-the-go use. The 14-inch display features a resolution of 1920x1080 and is housed in a slim and lightweight body. The laptop runs on an Intel Core i5 processor and has 8GB of RAM, which delivers solid performance for everyday use.",
      review_user: {name: "Rashedul Alom", image: "/assets/review/profile-icon.png", upload_date: "15 days ago"}
    },

  ]